import { requestApi } from './Api';

export const getVideosList = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/videos/list',
    params
  });

export const initiateVideoUpload = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/videos/upload/initiate',
    params
  });

export const presignVideoUpload = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/videos/upload/presign',
    params
  });

export const completeVideoUpload = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/videos/upload/complete',
    params
  });

export const deleteVideo = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/videos/delete',
    params
  });

export const activateVideo = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/videos/activate',
    params
  });
